'use strict';

(function ($) {
  var methods = {
    init: function (/*options*/) {
      /*var opts = $.extend({}, $.fn.widget_jobQueue.defaults, options);*/

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('widget-job-queue-init')) {
          return;
        }

        $this.addClass('widget-job-queue-init');

        $this.on('click', '.my-job-queue', function (/*e*/) {
          $this.find('button[type="submit"][name$="my_job_queue"]').click();
          return false;
        });
      });
    },
  };

  $.fn.widget_jobQueue = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.widget_jobQueue');
    }

  };

  $.fn.widget_jobQueue.defaults = {};

})(jQuery);
